{
  "newAnnouncement": "A une nouvelle annonce",
  "notification": "Notifications et annonces",
  "unread": "notifications non lues"
}
